// extracted by mini-css-extract-plugin
export default {"word":"lessonText_word__6GJXQ","wordButton":"lessonText_wordButton__mbAR3"};